import { useEffect, useRef } from "react"
import lottie from "lottie-web/build/player/lottie_light"
import animationData from "../anim/wine-loader.json"
import "./Loader.css"

// The app-wide wine-glass loader, the same Lottie the native app plays from
// BaseViewModel.showLoader().
export default function Loader({ overlay = false, label = "Loading" }) {
  const holderRef = useRef(null)

  useEffect(() => {
    const animation = lottie.loadAnimation({
      container: holderRef.current,
      renderer: "svg",
      loop: true,
      autoplay: true,
      animationData
    })
    return () => animation.destroy()
  }, [])

  return (
    <div className={overlay ? "loader loader--overlay" : "loader"} role="status">
      <div className="loader__art" ref={holderRef} aria-hidden="true" />
      <span className="visually-hidden">{label}</span>
    </div>
  )
}
